import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { RemoteConfigService } from '@app/core/firebase/remote-config/remote-config.service';

export const provideInitializeRemoteConfig = (): EnvironmentProviders[] => {
  return [
    provideAppInitializer(() => {
      inject(RemoteConfigService);
    })
  ];
};
